import {
  Check, Play, Package, MessageSquare,
  Wrench, Plug, Code2,
} from 'lucide-react';
import { Button } from '@/components/ui/button';

const SOLUTIONS = [
  {
    icon: Plug,
    title: 'Praxis-Integrationen',
    detail: 'Anbindung an Abrechnung, Kalender, Dokumentenablage oder vorhandene Praxisprozesse nach gemeinsamer Abnahme.',
  },
  {
    icon: Package,
    title: 'Modularer MVP',
    detail: 'Aktivieren Sie nur, was Sie im Alltag brauchen: Patientenakte, Teletherapie, Portal, Dokumentation, Rechnungen und Nachrichten.',
  },
  {
    icon: Code2,
    title: 'Dokumentationsvorlagen',
    detail: 'Eigene Textbausteine und Vorlagen bleiben fachlich von Ihrer Praxis verantwortet und werden nicht als KI-Empfehlung ausgespielt.',
  },
];

export const CustomSolutions = () => (
  <section className="py-16 bg-secondary/10">
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-800 text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
            <Wrench className="w-3 h-3" />
            Maßgeschneiderte Lösungen
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight">
            Icarus D&D - angepasst auf Ihre Praxis.
          </h2>
          <p className="mt-3 text-gray-700 leading-relaxed">
            Wir liefern die Schaltzentrale für Ihren Praxisalltag und passen Abläufe dort an,
            wo es die Dokumentation, Abrechnung oder Zusammenarbeit wirklich leichter macht.
          </p>
          <div className="mt-6 space-y-3">
            {SOLUTIONS.map(({ icon: Icon, title, detail }) => (
              <div key={title} className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-amber-50 flex items-center justify-center shrink-0 mt-0.5">
                  <Icon className="w-4 h-4 text-amber-600" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground">{title}</p>
                  <p className="text-xs text-gray-600 mt-0.5 leading-relaxed">{detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-card rounded-2xl border border-border p-6 md:p-8">
          <h3 className="font-bold text-foreground mb-1">Interesse an einer individuellen Lösung?</h3>
          <p className="text-sm text-gray-600 mb-5">
            Schreiben Sie uns – wir melden uns innerhalb von 24 Stunden mit einem ersten Konzept.
          </p>
          <div className="space-y-3">
            <a href="mailto:info@icarus-health.de?subject=Individuelle%20Anpassung%20D%3AE%3AF%3AY" className="block">
              <Button size="lg" className="w-full bg-primary hover:bg-primary/90 text-white rounded-xl h-12">
                <MessageSquare className="w-4 h-4 mr-2" />
                Anfrage senden
              </Button>
            </a>
            <a href="mailto:info@icarus-health.de?subject=Demo-Anfrage%20D%3AE%3AF%3AY" className="block">
              <Button size="lg" variant="outline" className="w-full rounded-xl h-12">
                <Play className="w-4 h-4 mr-2" />
                Demo vereinbaren
              </Button>
            </a>
          </div>
          <div className="mt-5 pt-5 border-t border-border">
            <div className="flex flex-wrap gap-2">
              {['Kalender', 'Abrechnung', 'Patientenportal', 'Teletherapie', 'Doku-Vorlagen'].map(tag => (
                <span key={tag} className="inline-flex items-center gap-1 bg-secondary/50 text-foreground text-xs font-medium px-2.5 py-1 rounded-full">
                  <Check className="w-3 h-3 text-primary" />
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
